// 应用配置
export const config = {
  // 应用标题
  title: '应急科技推介平台',
  
  // API基础地址 - 从环境变量获取，支持开发和生产环境
  // 生产环境使用相对路径，自动适配测试域名和正式域名
  baseURL: process.env.NODE_ENV === 'development' 
    ? (process.env.VUE_APP_BASE_API || '/api')  // 开发环境使用代理或环境变量
    : (process.env.VUE_APP_BASE_API || (() => {
        // 生产环境：优先使用环境变量，否则根据当前域名自动判断
        if (typeof window !== 'undefined') {
          const hostname = window.location.hostname
          // 如果是测试域名或正式域名，使用相对路径（自动适配）
          if (hostname.includes('zgyjkj.com')) {
            return '/api'
          }
          // 其他情况使用正式域名
          return 'https://www.zgyjkj.com/api'
        }
        return 'https://www.zgyjkj.com/api'
      })()),
  
  // Merchant端URL配置
  merchantBaseUrl: process.env.NODE_ENV === 'development' 
    ? 'http://localhost:8082'  // 开发环境
    : 'https://merchant.zgyjkj.com',  // 生产环境
  
  // 请求超时时间（30秒，平衡响应速度和稳定性）
  timeout: 30000,
  
  // 请求重试配置
  retry: {
    maxRetries: 2,        // 最大重试次数
    retryDelay: 1000,     // 重试间隔（毫秒）
    retryableStatuses: [408, 429, 500, 502, 503, 504] // 需要重试的状态码
  },
  
  // 分页配置
  pagination: {
    pageSize: 10,
    pageSizes: [10, 20, 50, 100]
  },
  
  // 文件上传配置
  upload: {
    maxSize: 10 * 1024 * 1024, // 10MB
    allowedTypes: ['image/jpeg', 'image/png', 'image/gif', 'application/pdf'],
    action: '/upload'
  },
  
  // 地图配置
  map: {
    key: 'your-map-key',
    center: [116.397428, 39.90923], // 北京
    zoom: 10
  },
  
  // 主题配置
  theme: {
    primaryColor: '#667eea',
    secondaryColor: '#764ba2'
  }
}

// 开发环境配置
export const devConfig = {
  ...config,
  debug: true,
  mock: false
}

// 生产环境配置
export const prodConfig = {
  ...config,
  debug: false,
  mock: false
}

// 导出当前环境配置
export default process.env.NODE_ENV === 'development' ? devConfig : prodConfig 